module.exports = __webpack_public_path__ + "img/2.30ec23d6.jpg";